<template>
  <li>
    <span class="status" v-if="widgetInfo.value || !isNaN(widgetInfo.value)">{{widgetInfo.value}}<span class="small" v-show="!isNaN(widgetInfo.value)">{{widgetInfo.rscUnit}}</span>
    </span>
    <span class="status" v-else>{{ EMPTY_TEXT }}</span>
    <span>{{widgetInfo.label}}<i v-if="widgetInfo.subLabel">{{widgetInfo.subLabel}}</i></span>
    
  </li>
</template>

<script>
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT } from '@/utils/string';

export default {
  name: 'WPerfBodyInfo',
  props: {
    widgetInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      EMPTY_TEXT,
    };
  },
  watch: {
    widgetInfo: {
      handler(widgetValue) {
        if (widgetValue.rscDatatypeId === 'BOOL') {
          if (widgetValue.rsctypeId === 'FFIREDS' || widgetValue.rsctypeId === 'FWLDS') {
            // 누수감지센서와 소방감지 센서는 1이 비정상
            switch (widgetValue.value) {
              case '1':
                widgetValue.value = '비정상'; break;
              case '0':
                widgetValue.value = '정상'; break;
              default: break;
            }
          } else {
            switch (widgetValue.value) {
              case '1':
                widgetValue.value = '정상'; break;
              case '0':
                widgetValue.value = '비정상'; break;
              default: break;
            }
          }
        } else if (widgetValue.rscUnit && widgetValue.rscUnit.toUpperCase() === 'COUNT') {
          widgetValue.rscUnit = '';
        } else if (widgetValue.rscUnit) {
          let convertedValue = convertValuByUnit(widgetValue.value, widgetValue.rscUnit, true, true, false);
          if (convertedValue) {
            if (convertedValue.indexOf('.') > -1) {
              // [18.06.15 UX팀 협의] 소수점 이하의 값은 rscUnit과 같은 사이즈로 출력되도록 하나의 태그 안에 사용
              widgetValue.value = convertedValue.split('.')[0];
              widgetValue.rscUnit = `.${convertedValue.split('.')[1]}`;
            } else {
              // convertedValue에서 unit 추출
              const convertedUnit = convertedValue.replace(/^[-]?[0-9]*[.]?[0-9]*[ ]?/g, '');
              convertedValue = convertedValue.split(convertedUnit)[0].replace(/[ ]?/g, '');
              widgetValue.value = convertedValue;
              widgetValue.rscUnit = convertedUnit;
            }
          }
        }
      },
      immediate: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/PerfBodyInfo.vue